import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createMoodleConfig } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useCreateMoodleConfig = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: createMoodleConfig,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: moodleQueryKeys.getMoodleConfigs(),
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
